export const KANBAN_PARENT_TYPE = {
  PROJECT: "Project",
  SCOPE: "Scope",
  NONE: null,
};

export const KANBAN_STATUS = {
  IN_PROGRESS: 0,
  MONITORING: 1,
  SLIPPING: 2,
  COMPLETED: 3,
  ON_HOLD: 4,
};

export const KANBAN_STATUS_LABEL = {
  [KANBAN_STATUS.IN_PROGRESS]: "In Progress",
  [KANBAN_STATUS.MONITORING]: "Monitoring",
  [KANBAN_STATUS.SLIPPING]: "Slipping",
  [KANBAN_STATUS.COMPLETED]: "Completed",
  [KANBAN_STATUS.ON_HOLD]: "On Hold",
};

export const LANE_ORDER = [
  KANBAN_STATUS.ON_HOLD,
  KANBAN_STATUS.IN_PROGRESS,
  KANBAN_STATUS.MONITORING,
  KANBAN_STATUS.SLIPPING,
  KANBAN_STATUS.COMPLETED,
];

/**
 * Estimated card height in pixels, used to calculate initial page size.
 */
export const ESTIMATED_CARD_HEIGHT = 140;


export const KANBAN_ACTIONS = {
  EDIT: 0,
  DUPLICATE: 1,
  MOVE: 2,
  DELETE: 3,
  CREATE: 4
};